import { render, staticRenderFns } from "./ModalConfirmDeduplication.vue?vue&type=template&id=58634061"
import script from "./ModalConfirmDeduplication.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDeduplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports